import { useState } from 'react';
import CampaignIcon from '@mui/icons-material/Campaign';
import CloseIcon from '@mui/icons-material/Close';

export default function WindingDownBanner() {
    // In-memory only: closing hides it until the next page refresh.
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    const handleClose = () => setVisible(false);

    return (
        <div
            role="alert"
            className="relative mt-4 mr-2 sm:mr-4 rounded-xl border-2 border-blue-400 bg-white px-4 py-3 shadow-sm"
        >
            <button
                type="button"
                id="winding-down-banner-close"
                aria-label="Dismiss announcement"
                onClick={handleClose}
                className="absolute right-3 top-3 rounded-full p-1 text-gray-700 hover:bg-gray-100 transition-colors"
            >
                <CloseIcon fontSize="small" />
            </button>

            <div className="flex items-center gap-2">
                <CampaignIcon className="text-blue-600" />
                <span className="rounded-full border border-blue-500 px-2 py-0.5 text-xs font-medium text-blue-600">
                    Important Update
                </span>
            </div>

            <p className="mt-2 text-base sm:text-lg text-gray-900">HoSaksham is winding down on</p>
            <p className="text-xl sm:text-2xl font-medium text-red-600">December 1, 2026.</p>

            <p className="mt-2 text-sm text-gray-600">
                We will do our best to make the transition as smooth as possible. Thank you for your trust and support. <span aria-hidden="true">❤️</span>
            </p>
        </div>
    );
}
